export default __webpack_public_path__ + "static/char-s-29-en-c8701e021af94e96055adbef9910998b.png";